<template>
  <div id="app">
    <Header @on-product="onProduct" @on-service="onService" />
    <router-view ref="view" />
    <Footer />
  </div>
</template>

<script>
import Header from "@c/Header";
import Footer from "@c/Footer";

export default {
  provide() {
    return {
      reload: this.reload
    };
  },

  data() {
    return {
      isRouterAlive: true,
      timeout: null
    };
  },
  components: {
    Header,
    Footer
  },
  methods: {
    onProduct() {
      // console.log(this.$refs.view);
      // this.$refs.view.productList({
      //   cat: v.id,
      //   page: 1,
      //   limit: 100
      // });
      this.timeout = setTimeout(() => {
        clearTimeout(this.timeout);
        this.$router.go(0);
      }, 300);
    },
    onService() {
      this.timeout = setTimeout(() => {
        clearTimeout(this.timeout);
        this.$router.go(0);
      }, 300);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
        console.log("reload");
      });
    }
  }
};
</script>

<style lang="less">
html,
body {
  overflow-x: hidden;
  box-sizing: border-box;
  height: 100%;
}

html {
  --color-white: #fff;
  --color-grey-white: #fffefe;
  --color-grey: #f1f2f6;
  --color-light-grey: #787878;
  --color-bright-grey: #2d2d2d;
  --color-green: #59ac6a;
  --color-black: #000;
  --color-light-black: #333;
  --color-light-grey: #666;
  --color-bright-black: #999;
  --color-grey-black: #363636;
  --color-line: #eaeaea;
  --color-line-black: #1b1b1b;
  --color-line-grey: #e6e6e6;
  --color-line-light-grey: #616161;
  --color-line-light: #d9d9d9;
  --color-item: RBG(245, 245, 245);
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

#app {
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.main-app {
  //padding-bottom: 80px;
  min-height: 100vh;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
}

.content {
  min-height: 100vh;
}

img {
  max-width: 100%;
}

input {
  outline: none;
}

a {
  color: var(--color-green);
}

.center {
  text-align: center;
}

.cursor {
  cursor: pointer;
}

.breadcrumb-com {
  .el-breadcrumb__inner,
  .el-breadcrumb__inner {
    color: var(--color-light-black);
    & > a,
    &.is-link {
      font-weight: normal;
      color: var(--color-light-black);
      &:hover {
        color: var(--color-green);
      }
    }
  }
}

.section-title {
  display: flex;
  height: 100px;
  align-items: center;
  font-size: 20px;
  color: var(--color-light-black);
  font-weight: 700;
}

.w-auto,
.w-100 {
  width: 100%;
}

.pagination {
  text-align: center;
  .el-pager li {
    &:hover {
      color: var(--color-green);
    }
    &.active {
      min-width: 28px;
      color: var(--color-white);
      background: var(--color-green);
      border-radius: 100%;
    }
  }
}

.el-table thead {
  color: #222 !important;
}

.el-table td {
  border-bottom: none !important;
}

.el-table::before {
  background: none !important;
}

.form-com {
  .el-button--success {
    line-height: initial;
    // font-size: 16px;
    background-color: var(--color-green);
    border-color: var(--color-green);
  }
  .el-button--text {
    //font-size: 14px;
    color: var(--color-light-grey);

    &:hover,
    &:active {
      color: var(--color-green);
    }
  }
}

.timeline {
  clear: both;
  overflow: hidden;
  padding-top: 40px;

  .time-item {
    display: flex;
    position: relative;
    border-right: 2px dotted var(--color-light-black);
    padding: 0 30px 60px;
    text-align: right;
    width: 50%;
    float: left;
    margin-bottom: 2px;
    cursor: pointer;

    &::before {
      position: absolute;
      top: 0;
      left: -8px;
      display: inline-block;
      content: "";
      width: 15px;
      height: 15px;
      border-radius: 100%;
      background: var(--color-green);
    }

    &:nth-child(odd) {
      width: calc(50% + 2px);
      float: right;
      border-right: 0;
      border-left: 2px dotted var(--color-light-black);
      text-align: left;
    }
    &:nth-child(even) {
      flex-direction: row-reverse;
      &::before {
        left: initial;
        right: -8px;
      }

      .time-info {
        text-align: left;
      }
    }

    .date-box {
      flex-basis: 20%;

      .date {
        font-size: 30px;
        color: var(--color-black);
      }

      .year {
        font-size: 16px;
        color: var(--color-light-grey);
      }
    }
    .time-info {
      flex-basis: 80%;
      font-size: 14px;
      color: var(--color-black);
    }
  }
}

.none {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-dialog.is-fullscreen {
  margin-top: 100px !important;
  width: 50% !important;
  height: auto !important;
  // position: relative;
  //   border-radius: 2px;
  //   box-shadow: 0 1px 3px rgba(0,0,0,.3);
  //   box-sizing: border-box;
  //   width: 50%;
}
.el-dialog {
  margin-top: 50px;
}

.el-menu-item:focus,
.el-menu-item:hover,
// .el-menu,
.el-submenu__title:focus,
.el-submenu__title:hover {
  background: rgba(0, 0, 0, 0.9) !important;
}

.el-message {
  top: 45% !important;
}

.el-radio__input.is-checked .el-radio__inner {
  background: var(--color-green) ;
  border-color: var(--color-green) 
}
.el-radio__input.is-checked + .el-radio__label {
  color: var(--color-green) ;
}

@media only screen and (max-width: 767px) {
  .el-button {
    width: 100%;
  }
  .main-app {
    //padding-bottom: 180px;
  }
  .section-title {
    padding: 0 10px;
    height: 50px;
  }
  .content {
    padding: 0 10px;
  }
  .el-dialog.is-fullscreen {
    margin-top: 0 !important;
    width: 100% !important;
  }
  .el-dialog {
    margin-top: 0;
  }
}
</style>
